import { trigger, animate, transition, style } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/core/services/common/common.service';
import { Toast, ToastService } from 'src/app/core/services/toast/toast.service';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('slideFade', [
            transition(':enter', [
                style({ transform: 'translateY(-30px)', opacity: 0 }),
                animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ transform: 'translateY(-30px)', opacity: 0 }))
            ])
        ])
    ]
})
export class ToastComponent implements OnInit {

    @Input() toast!: Toast;


    @HostBinding('@slideFade') fadeSlide = true;

    constructor(private _toast: ToastService,) {

    }

    ngOnInit(): void {

    }

    getToastIcon(): string {
        const icons = {
            success: 'assets/toast-icon/success.svg',
            error: 'assets/toast-icon/error.svg',
            warning: 'assets/toast-icon/warning.svg',
            neutral: 'assets/toast-icon/neutral.svg',
            notification: 'assets/toast-icon/notification.svg'
        };
        return icons[this.toast.type] || icons['neutral'];
    }

    getToastClass(): string {
        const classes = {
            success: 'success',
            error: 'error',
            warning: 'warning',
            notification: 'notification',
            neutral: 'neutral'
        };
        return classes[this.toast.type] || 'neutral';
    }

    pauseToast() {
        this._toast.pauseToast(this.toast.id);
    }

    // Resume the toast when mouse leaves
    resumeToast() {
        this._toast.resumeToast(this.toast.id);
    }

    // Close the toast (remove it)
    closeToast() {
        this._toast.removeToast(this.toast.id);
    }
    ngOnDestroy(): void {
        // Cleanup the toast when it gets destroyed
        this._toast.removeToast(this.toast.id);
    }

}
